import { useMsal } from "@azure/msal-react";
import Tooltip from "@mui/material/Tooltip";

// import Button from '@mui/material/Button';

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserMaintanenceData } from "../Redux/UserMaintanence";
import "./LeftContainer.css";
import FAQ from "../FAQ";

function LeftContainer({
  mailerParent,
  mailerChild,
  setMailerParent,
  setMailerChild,
  categoryName,
  setCategoryName,
  // setActiveScreen,
}) {
  const [userRoleAccessMenu, setUserRoleAccessMenu] = useState([]);
  const [mailerFlag, setMailerFlag] = useState(false);
  const [socialFlag, setSocialFlag] = useState(false);
  const [endorsementFlag, setEndorsementFlag] = useState(false);
  const [buildCampaignFlag, setBuildCampaignFlag] = useState(false);
  const [childCategory, setChildCategory] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
  const dispatch = useDispatch();

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";
  if (activeAccount) {
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
  }

  useEffect(() => {
    dispatch(getUserMaintanenceData());
  }, []);

  useEffect(() => {
    setUserRoleAccessMenu(userData);
  }, [userData]);

   let filteredUserAccesRole = userRoleAccessMenu?.length>0
  ? userRoleAccessMenu.find((user) => user.Enterprise_ID === loggedInEnterpriseId)
  : null;

let typeOfUser =
    filteredUserAccesRole?
      (filteredUserAccesRole.Admin === "yes"
      ? "Admin"
      : filteredUserAccesRole.Approver === "yes"
      ? "Approver"
      : filteredUserAccesRole.Requestor === "yes"
      ? "Requestor"
      : filteredUserAccesRole.Designer === "yes"
      ? "Designer"
      : "inactive"
      ): "request_access"

  const additionalRights = filteredUserAccesRole?.Designer === "yes" ? "Designer" : "" ;


  const handleMailerParent = (parentValue) => {
    setMailerParent(parentValue);
    if (parentValue === "Mailer") {
      setMailerFlag(!mailerFlag);
      setSocialFlag(false);
      setEndorsementFlag(false);
      setBuildCampaignFlag(false);
    } else if (parentValue === "Social Engagement") {
      setMailerFlag(false);
      setSocialFlag(!socialFlag);
      setEndorsementFlag(false);
      setBuildCampaignFlag(false);
    } else if (parentValue == "BuildCampaign") {
      setMailerFlag(false);
      setSocialFlag(false);
      setEndorsementFlag(false);
      setBuildCampaignFlag(true);
    } else {
      setMailerFlag(false);
      setSocialFlag(false);
      setEndorsementFlag(!endorsementFlag);
      setBuildCampaignFlag(false);
    }
  };

  const handleMailerChild = (childValue) => {
    setMailerChild(childValue);
  };

  return (
    <>
      <div className="accordion-container">
        <div className="accordion-wrap">
          <div className="new-wrap">
            <h3>Create New</h3>

            <div
              className={
                // mailerParent === "BuildCampaign" && buildCampaignFlag
                // ? "accordion-mailer-wrap"
                // :
                "accordion-mailer-wrap-na"
              }
            >
              <div
                className="category-content-build"
                onClick={() => {
                  handleMailerParent("BuildCampaign");
                  handleMailerChild("buildcam");
                }}
                style={{ display: "flex", marginBottom: "-7px" }}
              >
                <p
                  className={
                    mailerParent === "BuildCampaign" && buildCampaignFlag
                      ? "category-name comms"
                      : "category-name-active comms"
                  }
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/Images/build_gray.png"}
                    style={{ width: "13%", marginRight: "5px" }}
                  ></img>
                  {/* Build Your Campaign */}
                  Campaigns
                </p>
              </div>
            </div>
            <div className="standalone-wrap">
              <div
                className={
                  // mailerParent === "BuildCampaign" && buildCampaignFlag
                  // ? "accordion-mailer-wrap"
                  // :
                  "accordion-mailer-wrap-na"
                }
              >
                <div
                  className="category-content-build"
                  onClick={() => {
                    handleMailerParent("BuildCampaign");
                    handleMailerChild("buildcam");
                  }}
                  style={{ display: "flex", borderBottom: "1px solid #b5c1e7" }}
                >
                  <p
                    className={
                      mailerParent === "BuildCampaign" && buildCampaignFlag
                        ? "category-name"
                        : "category-name-active"
                    }
                    style={{ display: "flex", fontSize: "13px" }}
                  >
                    Build Your Campaign
                    {/* Campaigns */}
                  </p>
                  <img
                    src={process.env.PUBLIC_URL + "/Images/plus_icon.png"}
                  ></img>
                </div>
              </div>
            </div>

            <div
              className={
                // mailerParent === "BuildCampaign" && buildCampaignFlag
                // ? "accordion-mailer-wrap"
                // :
                "accordion-mailer-wrap-na"
              }
            >
              <div
                className="category-content-build"
                style={{ display: "flex", marginBottom: "-7px" }}
              >
                <p
                  // className={
                  //   mailerParent === "BuildCampaign" && buildCampaignFlag
                  //     ? "category-name"
                  //     : "category-name-active"
                  // }
                  className="category-name comms"
                >
                  {/* <img
                      src={process.env.PUBLIC_URL + "/Images/mailer.png"}
                      className="mailer-left-img"
                      style={{ width: "20%" }}
                    ></img> */}
                  <img
                    src={process.env.PUBLIC_URL + "/Images/mailer_gray.png"}
                    style={{ width: "11%", marginRight: "5px" }}
                  ></img>
                  Communications
                </p>
                {/* <img
                  src={process.env.PUBLIC_URL + "/Images/plus_icon.png"}
                ></img> */}
              </div>
            </div>

            {/* <div className="standalone-header" style={{ marginLeft: "3%" }}>
              <h3>Stand Alone Communications</h3>
            </div> */}

            <div className="standalone-wrap">
              <div
                className={
                  mailerParent === "Mailer" && mailerFlag
                    ? "accordion-mailer-wrap"
                    : "accordion-mailer-wrap-na"
                }
              >
                <div
                  className="category-content"
                  onClick={() => {
                    handleMailerParent("Mailer");
                    setMailerChild(null);
                  }}
                >
                  <p
                    className={
                      mailerParent === "Mailer" && mailerFlag
                        ? "category-name"
                        : "category-name-active"
                    }
                  >
                    Mailer
                  </p>
                  <img
                    src={
                      mailerParent === "Mailer" && mailerFlag
                        ? process.env.PUBLIC_URL + "/Images/minus_icon.png"
                        : process.env.PUBLIC_URL + "/Images/plus_icon.png"
                    }
                  ></img>
                </div>
                <ul
                  className={
                    mailerParent == "Mailer" && mailerFlag
                      ? "accordion-child-ul-active"
                      : "accordion-child-ul"
                  }
                >
                  <Tooltip
                    title="Sparks curiosity, encouraging the audience to seek more details before the launch." // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Teaser" && "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Teaser`)}
                    >
                      Teaser
                    </li>{" "}
                  </Tooltip>
                  <Tooltip
                    title="Announces a new program or tool, offering details and inviting recipients to engage." // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Launch" && "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Launch`)}
                    >
                      Launch/Nomination/Registration
                    </li>
                  </Tooltip>

                  {/* <li
                  className={
                    mailerChild == "launch" && "accordion-child-li-active"
                  }
                  onClick={() => handleMailerChild(`launch`)}
                >
                    {categoryName === "Microsite/Tool/Platform"
                    ? "Launch/Introduction"
                    : "Launch/Nomination/Registration"}
                </li> */}
                  {/* {categoryName === "event" || categoryName === "webinars" ? (
                  <li>Invite</li>
                ) : (
                  ""
                )} */}
                  {/* <li>Invite</li> */}
                  {/* {categoryName === "Microsite/Tool/Platform" ? (
                  ""
                ) : (
                  <li>Follow-up/Reminder</li>
                )} */}
                  <Tooltip
                    title="Reminds recipients to complete an upcoming task or action, or meet a deadline. " // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Reminder" && "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Reminder`)}
                    >
                      Follow-up/Reminder
                    </li>
                  </Tooltip>
                  {/* {categoryName === "Microsite/Tool/Platform" ? "" : <li>Nudge</li>} */}
                  <Tooltip
                    title="Encourages recipients to participate in an expected action aiming to boost engagement/participation." // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Nudge" && "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Nudge`)}
                    >
                      Nudge
                    </li>
                  </Tooltip>
                  {/* {categoryName === "Microsite/Tool/Platform" || categoryName === "webinars" ? (
                  ""
                ) : (
                  <li>Recognition</li>
                )} */}
                  <Tooltip
                    title="Acknowledges and celebrates achievements or milestones, highlighting success and expressing gratitude." // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Recognition" &&
                        "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Recognition`)}
                    >
                      Recognition
                    </li>
                  </Tooltip>
                  <Tooltip
                    title="Formally concludes a program/event, acknowledging completion and providing final details." // Text for the tooltip
                    placement="right-start" // Positioning the tooltip at the top right
                    arrow // Adds an arrow to the tooltip
                  >
                    <li
                      className={
                        mailerChild == "Closure" && "accordion-child-li-active"
                      }
                      onClick={() => handleMailerChild(`Closure`)}
                    >
                      Closure/Highlights
                    </li>
                  </Tooltip>
                  {/* {categoryName === "Microsite/Tool/Platform" ? (
                  ""
                ) : (
                  <li>Closure/Highlights</li>
                )} */}
                </ul>
              </div>
              <div
                className={
                  mailerParent === "Social Engagement" && socialFlag
                    ? "accordion-mailer-wrap"
                    : "accordion-mailer-wrap-na"
                }
              >
                <div
                  className="category-content"
                  onClick={() => {
                    handleMailerParent("Social Engagement");
                    setMailerChild(null);
                  }}
                >
                  <p className="category-name">Social Engagement</p>
                  <img
                    src={
                      mailerParent === "Social Engagement" &&
                      socialFlag === true
                        ? process.env.PUBLIC_URL + "/Images/minus_icon.png"
                        : process.env.PUBLIC_URL + "/Images/plus_icon.png"
                    }
                  ></img>
                </div>
                <ul
                  className={
                    mailerParent === "Social Engagement" && socialFlag
                      ? "accordion-parent-ul-active accordion-parent-ul"
                      : "accordion-parent-ul-disabled accordion-parent-ul"
                  }
                >
                  <li
                    className="accordion-active"
                    onClick={(e) => setChildCategory("viva")}
                  >
                    <img
                      src={
                        childCategory === "viva"
                          ? process.env.PUBLIC_URL + "/Images/chevron-down.png"
                          : process.env.PUBLIC_URL + "/Images/chevron-right.png"
                      }
                      className={
                        childCategory === "viva"
                          ? "chev-down-img"
                          : "chev-right-img"
                      }
                    ></img>
                    <span
                      className={
                        childCategory === "viva" && "accordion-parent-ul-span"
                      }
                    >
                      Viva Engage
                    </span>
                    <ul
                      className={
                        childCategory == "viva"
                          ? "accordion-child-ul-active"
                          : "accordion-child-ul"
                      }
                    >
                      <Tooltip
                        title="Announces a new program or tool, offering details and inviting recipients to engage." // Text for the tooltip
                        placement="right-start" // Positioning the tooltip at the top right
                        arrow // Adds an arrow to the tooltip
                      >
                        <li
                          className={
                            mailerChild ==
                              "Viva-Launch/Nomination/Registration" &&
                            "accordion-child-li-active"
                          }
                          onClick={() =>
                            handleMailerChild(
                              `Viva-Launch/Nomination/Registration`
                            )
                          }
                        >
                          Launch/Nomination/Registration
                        </li>
                      </Tooltip>
                      <Tooltip
                        title="Reminds recipients to complete an upcoming task or action, or meet a deadline. " // Text for the tooltip
                        placement="right-start" // Positioning the tooltip at the top right
                        arrow // Adds an arrow to the tooltip
                      >
                        <li
                          className={
                            mailerChild == "Viva-Follow-up/Reminder" &&
                            "accordion-child-li-active"
                          }
                          onClick={() =>
                            handleMailerChild(`Viva-Follow-up/Reminder`)
                          }
                        >
                          Follow-up/Reminder
                        </li>
                      </Tooltip>
                      <Tooltip
                        title="Encourages recipients to participate in an expected action aiming to boost engagement/participation." // Text for the tooltip
                        placement="right-start" // Positioning the tooltip at the top right
                        arrow // Adds an arrow to the tooltip
                      >
                        <li
                          className={
                            mailerChild == "Viva-Nudge" &&
                            "accordion-child-li-active"
                          }
                          onClick={() => handleMailerChild(`Viva-Nudge`)}
                        >
                          Nudge
                        </li>
                      </Tooltip>
                      <Tooltip
                        title="Acknowledges and celebrates achievements or milestones, highlighting success and expressing gratitude." // Text for the tooltip
                        placement="right-start" // Positioning the tooltip at the top right
                        arrow // Adds an arrow to the tooltip
                      >
                        <li
                          className={
                            mailerChild == "Viva-Recognition" &&
                            "accordion-child-li-active"
                          }
                          onClick={() => handleMailerChild(`Viva-Recognition`)}
                        >
                          Recognition
                        </li>
                      </Tooltip>
                    </ul>
                  </li>
                  <li
                    className="accordion-active"
                    onClick={(e) => setChildCategory("dipa")}
                  >
                    <img
                      src={
                        childCategory === "dipa"
                          ? process.env.PUBLIC_URL + "/Images/chevron-down.png"
                          : process.env.PUBLIC_URL + "/Images/chevron-right.png"
                      }
                      className={
                        childCategory === "dipa"
                          ? "chev-down-img"
                          : "chev-right-img"
                      }
                    ></img>
                    <span
                      className={
                        childCategory === "dipa" && "accordion-parent-ul-span"
                      }
                    >
                      DiPA
                    </span>
                    <ul
                      className={
                        childCategory == "dipa"
                          ? "accordion-child-ul-active"
                          : "accordion-child-ul"
                      }
                    >
                      <Tooltip
                        title="Sparks curiosity, encouraging the audience to seek more details before the launch." // Text for the tooltip
                        placement="right-start" // Positioning the tooltip at the top right
                        arrow // Adds an arrow to the tooltip
                      >
                        <li
                          className={
                            mailerChild == "Dipa-Teaser" &&
                            "accordion-child-li-active"
                          }
                          onClick={() => handleMailerChild(`Dipa-Teaser`)}
                        >
                          Teaser
                        </li>
                      </Tooltip>
                      {categoryName === "Microsite/Tool/Platform" ? (
                        <li>Launch/Introduction</li>
                      ) : (
                        <Tooltip
                          title="Announces a new program or tool, offering details and inviting recipients to engage." // Text for the tooltip
                          placement="right-start" // Positioning the tooltip at the top right
                          arrow // Adds an arrow to the tooltip
                        >
                          <li
                            className={
                              mailerChild == "Dipa-Launch" &&
                              "accordion-child-li-active"
                            }
                            onClick={() => handleMailerChild(`Dipa-Launch`)}
                          >
                            Launch/Nomination/Registration
                          </li>
                        </Tooltip>
                      )}
                    </ul>
                  </li>
                </ul>
              </div>
              {/* {categoryName === "Microsite/Tool/Platform" ? (
              ""
            ) : ( */}
              <div
                className={
                  mailerParent === "Endorsements" && endorsementFlag
                    ? "accordion-mailer-wrap"
                    : "accordion-mailer-wrap-na"
                }
              >
                <div
                  className="category-content"
                  onClick={() => {
                    handleMailerParent("Endorsements");
                    setMailerChild(null);
                  }}
                >
                  <p className="category-name">Endorsements</p>
                  <img
                    src={
                      mailerParent === "Endorsements" &&
                      endorsementFlag === true
                        ? process.env.PUBLIC_URL + "/Images/minus_icon.png"
                        : process.env.PUBLIC_URL + "/Images/plus_icon.png"
                    }
                  ></img>
                </div>
                <ul
                  className={
                    mailerParent === "Endorsements" && endorsementFlag
                      ? "accordion-parent-ul-active accordion-parent-ul"
                      : "accordion-parent-ul-disabled accordion-parent-ul"
                  }
                >
                  <li
                    className="accordion-active"
                    onClick={(e) => {
                      //  setChildCategory("E-Certificate");
                      handleMailerChild("E-Certificate");
                    }}
                  >
                    {/* <img
            src={
             childCategory === "certificate"
              ? process.env.PUBLIC_URL + "/Images/chevron-down.png"
              : process.env.PUBLIC_URL + "/Images/chevron-right.png"
            }
           className={
            childCategory === "E-Certificate" ? "chev-down-img" : "chev-right-img"
           }
          ></img> */}
                    <span
                      className={
                        mailerChild === "E-Certificate" &&
                        "accordion-parent-ul-span"
                      }
                    >
                      E-certificates
                    </span>
                    {/* <ul
           className={
            childCategory == "certificate"
             ? "accordion-child-ul-active"
             : "accordion-child-ul"
           }
          >
           <li>Participation</li>
           {categoryName === "program" ? <li>Completion</li> : ""}
           {categoryName === "webinars" ? "" : <li>Winner</li>}
           {categoryName === "webinars" ? "" : <li>Runner-up</li>}
          </ul> */}
                  </li>
                  <li
                    className="accordion-active"
                    onClick={(e) => handleMailerChild("Testimonial")}
                  >
                    {/* <img
           src={
            childCategory === "Testimonial"
             ? process.env.PUBLIC_URL + "/Images/chevron-down.png"
             : process.env.PUBLIC_URL + "/Images/chevron-right.png"
           }
           className={
            childCategory === "Testimonial" ? "chev-down-img" : "chev-right-img"
           }
          ></img> */}
                    <span
                      className={
                        mailerChild === "Testimonial" &&
                        "accordion-parent-ul-span"
                      }
                    >
                      Testimonials
                    </span>
                    {/* <ul
           className={
            childCategory == "testimonial"
             ? "accordion-child-ul-active"
             : "accordion-child-ul"
           }
          >
           <li>Participation</li>
           {categoryName === "program" ? <li>Completion</li> : ""}
          </ul> */}
                  </li>
                </ul>
              </div>
            </div>
            {/* )} */}


						<div
							className={
								"accordion-mailer-wrap-na"
							}
						>
							<div
								className="category-content-build"
								onClick={() => {
									handleMailerParent("BuildCampaign");
									handleMailerChild("buildcam");
								}}
								style={{ display: "flex", marginBottom: "-7px" }}
							>
								<p
									className={
										mailerParent === "BuildCampaign" && buildCampaignFlag
											? "category-name comms"
											: "category-name-active comms"
									}
									style={{ display: "flex", alignItems: "center" }}
								>
									<img
										src={process.env.PUBLIC_URL + "/Images/build_gray.png"}
										style={{ width: "13%", marginRight: "5px" }}
									></img>
									Design
								</p>
							</div>
						</div>
						<div className="standalone-wrap">
							<div
								className={
									"accordion-mailer-wrap-na"
								}
							>
								<div
									className="category-content-build"
									onClick={() => {
										handleMailerParent("BuildCampaign");
										handleMailerChild("Design");
									}}
									style={{ display: "flex", borderBottom: "1px solid #b5c1e7" }}
								>
									<p
										className={
											mailerParent === "BuildCampaign" && buildCampaignFlag
												? "category-name"
												: "category-name-active"
										}
										style={{ display: "flex", fontSize: "13px" }}
									>
										Request Design
									</p>
								</div>
							</div>
						</div>
          </div>
        </div>

        <div className="accordion-wrap-bottom">
          <div className="wrap-botton-row">
           {(typeOfUser === "Requestor" || typeOfUser === "Approver" || typeOfUser === "Admin") && ( 
            <div
              className="wrap-bottom-item-one"
              style={{ marginBottom: "0.9rem" }}
            >
              <img
                src={process.env.PUBLIC_URL + "/Images/MyContent_gray.png"}
                style={{ width: "18%" }}
              ></img>
              <p onClick={() => handleMailerChild("mycontent")}>MyContent</p>
            </div>)}

            {typeOfUser === "Admin" && (
              <div className="wrap-bottom-item-one">
                <img
                  src={process.env.PUBLIC_URL + "/Images/Admin_gray.png"}
                  style={{ width: "18%" }}
                ></img>
                <p onClick={() => handleMailerChild("user_maintenance")}>
                  Admin
                </p>
              </div>
            )}
          </div>

          <div className="wrap-botton-row">
            {(typeOfUser === "Approver" || typeOfUser === "Admin") && (
              <>
                <div
                  className="wrap-bottom-item-two"
                  style={{ marginBottom: "0.9rem" }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/Images/Approver_gray.png"}
                    style={{ width: "18%" }}
                  ></img>
                  <p
                    onClick={() => {
                      handleMailerChild("approver");
                      // setActiveScreen("default");
                    }}
                  >
                    {" "}
                    Approval
                  </p>
                </div>
              </>
            )}
            {typeOfUser === "Admin" && (
              <div className="wrap-bottom-item-two">
                <img
                  src={process.env.PUBLIC_URL + "/Images/Dashboard_gray.png"}
                  style={{ width: "18%" }}
                ></img>
                <p onClick={() => handleMailerChild("dashboard")}>Dashboard</p>
              </div>
            )}
          </div>

           <div className="wrap-botton-row">
            { additionalRights==='Designer' && (
              <>
                <div
                  className="wrap-bottom-item-two"
                  style={{ marginTop: "0.9rem" }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/Images/AI-image_icon.png"}
                    style={{ width: "15%" }}
                  ></img>
                  <p
                    onClick={() => {
                      handleMailerChild("designer");
                    }}
                  >
                    {" "}
                    My Designs
                  </p>
                </div>
              </>
            )}
            </div>
        </div>

        <div
          style={{
            color: "#002791",
            // display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="bottom-item">
            <div className="grid-container">
              <div
                className="grid-item"
                onClick={() => handleMailerChild("user-guide")}
              >
                <img
                  src={process.env.PUBLIC_URL + "/Images/user-guide.png"}
                  height="20px"
                  alt="User Guide"
                />
                <p>User Guide</p>
              </div>
              <div
                className="grid-item"
                onClick={() => handleMailerChild("testimonials")}
              >
                <img
                  src={process.env.PUBLIC_URL + "/Images/Testimonial.png"}
                  alt="Testimonials"
                />
                <p>Testimonials</p>
              </div>
              <div className="grid-item" onClick={handleOpen}>
                <img
                  src={process.env.PUBLIC_URL + "/Images/FAQ1.png"}
                  alt="FAQ"
                />
                <p>FAQs</p>
              </div>
              <div
                className="grid-item"
                onClick={() => handleMailerChild("Demo-Video")}
              >
                <img
                  src={process.env.PUBLIC_URL + "/Images/commsbuilder-demo.png"}
                  alt="Commsbuilder Demo"
                />
                <p>Commsbuilder Demo</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQ open={open} handleClose={handleClose} />
    </>
  );
}

export default LeftContainer;
